var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EntryFilter',{staticStyle:{"margin-bottom":"15px"},attrs:{"def":_vm.def},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('EntryList',{attrs:{"filter":_vm.filter,"selectable":true,"mark-entries":_vm.markEntries},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }